import classNames from 'classnames';
import { JSX } from 'react';

// components
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';

// types
import { IOrDisclaimerTextProps } from './or-disclaimer-text.types';

/**
 * Renders styled disclaimer or legal copy using Tailwind Typography (`prose`) and custom text size classes.
 *
 * Intended for rich text blocks like legal disclaimers, footnotes, or CMS-provided blurbs.
 * Uses `RenderRichText` under the hood to parse structured Contentstack rich text fields.
 */
export const OrDisclaimerText = ({
  text,
  textSize,
}: IOrDisclaimerTextProps): JSX.Element => {
  const textSizeClasses: { [key: string]: string } = {
    xs: 'prose [&>*]:text-xs prose-li:text-xs prose-ul:text-xs',
    sm: 'prose [&>*]:text-sm prose-li:text-sm prose-ul:text-sm',
    md: 'prose [&>*]:text-md prose-li:text-base prose-ul:text-base',
    lg: 'prose [&>*]:text-lg prose-li:text-lg prose-ul:text-lg',
    xl: 'prose [&>*]:text-xl prose-li:text-xl prose-ul:text-xl',
  };
  return (
    <section data-testid="or-disclaimer-text" className="container pb-5 pt-6">
      <RenderRichText
        body={text}
        useProse={true}
        className={classNames(
          'max-w-full [&>*]:text-skin-primary',
          textSizeClasses[textSize.toLowerCase()],
        )}
      />
    </section>
  );
};
